// Styles

import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import '@/styles/variables.scss';




// Vuetify
import { createVuetify } from 'vuetify'
import { DEFAULT_MODULE_COLORS } from '@/config/moduleColors'

const sportipsTheme = {
  dark: false,
  colors: {
    background: "#f6f8fd",
    'on-background': DEFAULT_MODULE_COLORS.text_color,

    primary: DEFAULT_MODULE_COLORS.primary,
    'on-primary': "#000",

    dark: DEFAULT_MODULE_COLORS.darkblue,
    'on-dark': '#f5f7f8',

    'dark-red': '#581e1e',
    'dark-green': '#23581e',

    'primary-dark': DEFAULT_MODULE_COLORS.primary_dark,

    'darkgrey': "#5e5e5e",

    darkblue: DEFAULT_MODULE_COLORS.darkblue,
    white: '#FFF',
    'on-white': DEFAULT_MODULE_COLORS.text_color,
    grey_1: "#fafafa",
    grey_3: "#f7f7f7",
    'on-grey_3': DEFAULT_MODULE_COLORS.text_color,
    grey_4: "#e5e5e5",
    'on-grey_4': DEFAULT_MODULE_COLORS.text_color,
    "lightblue": "#e8effc",


  }

}


export default createVuetify(
  {
    icons: {
      defaultSet: 'mdi',
    },
    theme: {
      defaultTheme: 'sportipsTheme',
      themes: {
        sportipsTheme,
      }
    },
    defaults: {
      global: {

      },
      VSheet: {
        elevation: 2,
        rounded: true,
      },
      VChip: {
        label: true,

      },
      VBtn: {
        variant: 'tonal',
      },
      VTextField: {
        density: 'compact',

      },
      VSelect: {
        density: 'compact',
      },
      VAutocomplete: {
        density: 'compact',
      },
      VRadio: {
        color: 'primary',
      },
      VDivider: {
        thickness: "2px",
      },
      VCheckbox: {
        density: 'compact',
      }

    }
  }
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
)
